/**
 * Nine-Slice Border
 *
 * Renders a pixel art border around content using the 9-slice technique:
 * a single corner image is flipped with CSS transforms for all four corners,
 * and edge images tile/stretch along the sides. Center is transparent.
 */

import React from 'react';
import styles from './NineSliceBorder.module.css';

interface NineSliceBorderProps {
  cornerSrc: string;
  edgeTopSrc: string;
  edgeLeftSrc: string;
  inset?: number;
  cornerSize?: number;
  className?: string;
}

export const NineSliceBorder: React.FC<NineSliceBorderProps> = ({
  cornerSrc,
  edgeTopSrc,
  edgeLeftSrc,
  inset = -12,
  cornerSize = 32,
  className,
}) => {
  const gridStyle: React.CSSProperties = {
    position: 'absolute',
    inset: `${inset}px`,
    zIndex: 0,
    pointerEvents: 'none',
    display: 'grid',
    gridTemplateColumns: `${cornerSize}px 1fr ${cornerSize}px`,
    gridTemplateRows: `${cornerSize}px 1fr ${cornerSize}px`,
  };

  return (
    <div style={gridStyle} className={className}>
      {/* Top row */}
      <div className={styles.cell}>
        <img src={cornerSrc} alt="" className={styles.pixelImg} />
      </div>
      <div className={styles.cell}>
        <img src={edgeTopSrc} alt="" className={styles.pixelImg} />
      </div>
      <div className={styles.cell}>
        <img src={cornerSrc} alt="" className={`${styles.pixelImg} ${styles.flipX}`} />
      </div>

      {/* Middle row */}
      <div className={styles.cell}>
        <img src={edgeLeftSrc} alt="" className={styles.pixelImg} />
      </div>
      <div />
      <div className={styles.cell}>
        <img src={edgeLeftSrc} alt="" className={`${styles.pixelImg} ${styles.flipX}`} />
      </div>

      {/* Bottom row */}
      <div className={styles.cell}>
        <img src={cornerSrc} alt="" className={`${styles.pixelImg} ${styles.flipY}`} />
      </div>
      <div className={styles.cell}>
        <img src={edgeTopSrc} alt="" className={`${styles.pixelImg} ${styles.flipY}`} />
      </div>
      <div className={styles.cell}>
        <img src={cornerSrc} alt="" className={`${styles.pixelImg} ${styles.flipXY}`} />
      </div>
    </div>
  );
};
